import {
  Component,
  HostListener, Inject,
  Input, PLATFORM_ID
} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {EVENT_CALENDAR_ROUTE, LOGIN_ROUTE} from "src/app/app-routing.module";
import {alphabetical, email, max_length_45, max_length_50, passwordStrengthValidator, required} from '@utility';
import {AbstractComponent} from "@components";
import {Lookups, RegisterUser} from "@model";
import {AuthenticationService} from "@services";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent extends AbstractComponent {
  @Input() genders: Lookups[] = [];

  signupComponentState: SignupComponentState = SignupComponentState.INITIAL;
  googleSigninButton: number = 400;

  inputForm: FormGroup<{
    firstName: FormControl<string | null>;
    lastName: FormControl<string | null>;
    password: FormControl<string | null>;
    gender: FormControl<string | null>;
    email: FormControl<string | null>
  }> = new FormGroup({
    email: new FormControl('', [
        required,
        email,
        max_length_50
      ]
    ),
    password: new FormControl('', [
      required,
      passwordStrengthValidator()
    ]),
    firstName: new FormControl('', [
      required,
      alphabetical,
      max_length_45
    ]),
    lastName: new FormControl('', [
      required,
      alphabetical,
      max_length_45
    ]),
    gender: new FormControl('', [])
  });

  public currentWindowWidth: number = 0;

  constructor(private authService: AuthenticationService, @Inject(PLATFORM_ID) private platformId: Object,
              private router: Router) {
    super();
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  setInitialState() {
    this.markAllAsUntouched(this.inputForm);
    this.inputForm.controls.email.setValue("");
    this.inputForm.controls.password.setValue("")
    this.inputForm.controls.firstName.setValue("");
    this.inputForm.controls.firstName.setValue("");
    this.inputForm.controls.gender.setValue("");
    this.signupComponentState = SignupComponentState.INITIAL;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.currentWindowWidth = window.innerWidth
  }

  onRegister(): void {
    if (!this.inputForm.valid) {
      for (const control in this.inputForm.controls) {
        this.inputForm.get(control)?.markAsTouched();
      }
      return;
    }
    this.authService.signUp(new RegisterUser(
        this.inputForm.value.email,
        this.inputForm.value.password,
        this.inputForm.value.firstName,
        this.inputForm.value.lastName,
        this.inputForm.value.gender),
      () => {
        this.signupComponentState = SignupComponentState.SUCCESS;

      }, () => {
        this.signupComponentState = SignupComponentState.ERROR;
      });
  }

  onSignup(): void {
    this.signupComponentState = SignupComponentState.SIGNUP;
  }

  toLogin(): void {
    this.router.navigate([LOGIN_ROUTE]);
  }

  onFacebookLogin(): void {
    this.authService.facebookSignIn();
  }

  toHome(): void {
    this.router.navigate([EVENT_CALENDAR_ROUTE]);
  }

  protected readonly SignupComponentState = SignupComponentState;
}

enum SignupComponentState {
  INITIAL,
  SIGNUP,
  SUCCESS,
  ERROR,
}
